import { useEffect, useState } from "react";
import { getUOM, postUOM } from "../services/services";
import { UOMInterface } from "../services/interface";
import { errorHandling } from "../services/errorHandling";
import { notifyError } from "src/assets/toastService";

const useUOM = () => {
  const [uom, setUOM] = useState<UOMInterface[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [formData, setFormData] = useState({
    conversion_factor: "",
    base_unit: "",
    uom_name: "",
  });
  const [reset, setReset] = useState();

  useEffect(() => {
    get();
  }, [reset]);

  const get = () => {
    setLoading(true);
    getUOM()
      .then((res: any) => {
        const filterData = res.data;
        setUOM(filterData);
        setLoading(false);
      })
      .catch((error) => {
        errorHandling(error);
        setLoading(false);
      });
  };

  const post = async (formData: UOMInterface) => {
    setLoading(true);
    if (Number(formData.conversion_factor) < 0) {
      notifyError("Conversion factor must be a positive number");
      setLoading(false);
      return;
    }
    try {
      const res = await postUOM(formData);
      get();
      setFormData({
        conversion_factor: "",
        base_unit: "",
        uom_name: "",
      });
      return res;
    } catch (error) {
      errorHandling(error);
      setLoading(false);
    }
  };

  return { uom, formData, setFormData, post, loading, setReset, reset };
};

export default useUOM;
